(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefdb2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefdb2"] = parcelRequire;
}
parcelRequire.register("i6yv0", function(module, exports) {
module.exports = {};

});

/*
|--------------------------------------------------------------------------
| App.JS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/ function $5cde60a45dc0f6ff$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $5cde60a45dc0f6ff$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $5cde60a45dc0f6ff$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $5cde60a45dc0f6ff$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ function $3911bfce698fbe4a$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $37faaaff56909290$var$extendStatics = function extendStatics1(d, b) {
    $37faaaff56909290$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $37faaaff56909290$var$extendStatics(d, b);
};
function $37faaaff56909290$export$a8ba968b8961cb8a(d, b) {
    var __ = function __() {
        this.constructor = d;
    };
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $37faaaff56909290$var$extendStatics(d, b);
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $37faaaff56909290$export$18ce0697a983be9b = function __assign1() {
    $37faaaff56909290$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $37faaaff56909290$export$18ce0697a983be9b.apply(this, arguments);
};
function $37faaaff56909290$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $37faaaff56909290$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $37faaaff56909290$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $37faaaff56909290$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    var accept = function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    };
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $37faaaff56909290$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $37faaaff56909290$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $3911bfce698fbe4a$export$5f0017c582d45a2d)(x)) === "symbol" ? x : "".concat(x);
}
function $37faaaff56909290$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $3911bfce698fbe4a$export$5f0017c582d45a2d)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $37faaaff56909290$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $37faaaff56909290$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $37faaaff56909290$export$67ebef60e6f28a6(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
}
var $37faaaff56909290$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $37faaaff56909290$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $37faaaff56909290$export$45d3717a4c69092e(o, m, p);
}
function $37faaaff56909290$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $37faaaff56909290$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $37faaaff56909290$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($37faaaff56909290$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $37faaaff56909290$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $37faaaff56909290$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $37faaaff56909290$export$10c90e4f7922046c(v) {
    return this instanceof $37faaaff56909290$export$10c90e4f7922046c ? (this.v = v, this) : new $37faaaff56909290$export$10c90e4f7922046c(v);
}
function $37faaaff56909290$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    var verb = function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    };
    var resume = function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    };
    var step = function step(r) {
        r.value instanceof $37faaaff56909290$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    };
    var fulfill = function fulfill(value) {
        resume("next", value);
    };
    var reject = function reject(value) {
        resume("throw", value);
    };
    var settle = function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
}
function $37faaaff56909290$export$bbd80228419bb833(o) {
    var verb = function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $37faaaff56909290$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    };
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
}
function $37faaaff56909290$export$e3b29a3d6162315f(o) {
    var verb = function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    };
    var settle = function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $37faaaff56909290$export$19a8beecd37a4c45 === "function" ? $37faaaff56909290$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
}
function $37faaaff56909290$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $37faaaff56909290$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $37faaaff56909290$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $37faaaff56909290$export$45d3717a4c69092e(result, mod, k);
    }
    $37faaaff56909290$var$__setModuleDefault(result, mod);
    return result;
}
function $37faaaff56909290$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $37faaaff56909290$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $37faaaff56909290$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $37faaaff56909290$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
var $37faaaff56909290$export$2e2bcd8739ae039 = {
    __extends: $37faaaff56909290$export$a8ba968b8961cb8a,
    __assign: $37faaaff56909290$export$18ce0697a983be9b,
    __rest: $37faaaff56909290$export$3c9a16f847548506,
    __decorate: $37faaaff56909290$export$29e00dfd3077644b,
    __param: $37faaaff56909290$export$d5ad3fd78186038f,
    __metadata: $37faaaff56909290$export$f1db080c865becb9,
    __awaiter: $37faaaff56909290$export$1050f835b63b671e,
    __generator: $37faaaff56909290$export$67ebef60e6f28a6,
    __createBinding: $37faaaff56909290$export$45d3717a4c69092e,
    __exportStar: $37faaaff56909290$export$f33643c0debef087,
    __values: $37faaaff56909290$export$19a8beecd37a4c45,
    __read: $37faaaff56909290$export$8d051b38c9118094,
    __spread: $37faaaff56909290$export$afc72e2116322959,
    __spreadArrays: $37faaaff56909290$export$6388937ca91ccae8,
    __spreadArray: $37faaaff56909290$export$1216008129fb82ed,
    __await: $37faaaff56909290$export$10c90e4f7922046c,
    __asyncGenerator: $37faaaff56909290$export$e427f37a30a4de9b,
    __asyncDelegator: $37faaaff56909290$export$bbd80228419bb833,
    __asyncValues: $37faaaff56909290$export$e3b29a3d6162315f,
    __makeTemplateObject: $37faaaff56909290$export$4fb47efe1390b86f,
    __importStar: $37faaaff56909290$export$c21735bcef00d192,
    __importDefault: $37faaaff56909290$export$da59b14a69baef04,
    __classPrivateFieldGet: $37faaaff56909290$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $37faaaff56909290$export$d40a35129aaff81f,
    __classPrivateFieldIn: $37faaaff56909290$export$81fdc39f203e4e04
};



var $045332d6670dfa00$var$autoTemplateComponent = function() {
    var _ref = (0, $5cde60a45dc0f6ff$export$7c398597f8905a1)(function() {
        var components, allComponents;
        return (0, $37faaaff56909290$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (parcelRequire("i6yv0"))
                    ];
                case 1:
                    components = _state.sent();
                    if (components) {
                        allComponents = Object.keys(components);
                        allComponents.forEach(function(component) {
                            var _Object_keys;
                            var parentComponent = components[component];
                            var hasChildren = (_Object_keys = Object.keys(parent)) === null || _Object_keys === void 0 ? void 0 : _Object_keys.length;
                            console.log("js-load-" + component);
                            if (document.getElementById("js-load-" + component) !== null) {
                                // First level components
                                for(var child in parentComponent){
                                    var childComponent = parentComponent[child];
                                    if (childComponent instanceof Function) childComponent();
                                }
                                // Lower level components
                                if (hasChildren) for(var child1 in parentComponent){
                                    var childComponent1 = parentComponent[child1][child1];
                                    if (childComponent1 instanceof Function) childComponent1();
                                }
                            }
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function autoTemplateComponent() {
        return _ref.apply(this, arguments);
    };
}();
var $045332d6670dfa00$export$2e2bcd8739ae039 = $045332d6670dfa00$var$autoTemplateComponent;


var $1ae577b3890a62ed$var$carousel = function() {
    var carousel = document.getElementById("js-carousel");
    var banner = document.getElementById("js-banner");
    banner && carousel && carousel.querySelectorAll("a").forEach(function(elm) {
        elm.addEventListener("mouseover", function(e) {
            for(var i = banner.classList.length - 1; i >= 0; i--){
                var className = banner.classList[i];
                if (className.startsWith("theme--")) banner.classList.remove(className);
            }
            banner.classList.add(e.target.dataset.theme);
            banner.querySelectorAll("img")[0].src = e.target.dataset.img ? e.target.dataset.img : banner.dataset.img;
        });
        elm.addEventListener("mouseleave", function(e) {
            banner.classList.remove(e.target.dataset.theme);
            banner.querySelectorAll("img")[0].src = banner.dataset.img;
        });
    });
};
var $1ae577b3890a62ed$export$2e2bcd8739ae039 = $1ae577b3890a62ed$var$carousel;


var $dff875e027806757$var$headerChange = function() {
    var header = document.getElementById("js-header");
    var headerHeight = header.offsetHeight;
    var prevScrollPos = window.pageYOffset || document.documentElement.scrollTop;
    window.addEventListener("scroll", function() {
        var currentScrollPos = window.pageYOffset || document.documentElement.scrollTop;
        if (currentScrollPos > prevScrollPos && currentScrollPos > headerHeight) header.classList.add("header-hide");
        else header.classList.remove("header-hide");
        prevScrollPos = currentScrollPos;
    });
};
var $dff875e027806757$export$2e2bcd8739ae039 = $dff875e027806757$var$headerChange;


var $a1b2017506b78aba$var$fileUpload = function() {
    var fileInputs = document.querySelectorAll(".contact-form input[type='file']");
    fileInputs && fileInputs.forEach(function(elm) {
        elm.addEventListener("change", function() {
            if (elm.files.length > 0) elm.classList.add("gf-file-uploaded");
            else elm.classList.remove("gf-file-uploaded");
        });
    });
};
var $a1b2017506b78aba$export$2e2bcd8739ae039 = $a1b2017506b78aba$var$fileUpload;


var $c1dad78f44c606ce$var$displayToggle = function(button, dropdown, className, body) {
    var buttonEl = document.querySelector(button);
    var dropdownEl = document.querySelector(dropdown);
    var bodyEl = document.querySelector(body);
    if (!buttonEl || !dropdownEl || !className) return null;
    buttonEl.addEventListener("click", function() {
        var allToggleBtns = document.querySelectorAll(".is-active[data-btn-toggle]");
        allToggleBtns && allToggleBtns.forEach(function(elm) {
            elm.classList.remove("is-active");
            elm.nextElementSibling.classList.add("hidden");
        });
        buttonEl.classList.toggle("is-active");
        if (bodyEl) bodyEl.classList.toggle("mobile-overflow");
        dropdownEl.classList.toggle(className);
    });
};
var $c1dad78f44c606ce$export$2e2bcd8739ae039 = $c1dad78f44c606ce$var$displayToggle;


window.addEventListener("DOMContentLoaded", function() {
    (0, $045332d6670dfa00$export$2e2bcd8739ae039)();
    (0, $dff875e027806757$export$2e2bcd8739ae039)();
    (0, $1ae577b3890a62ed$export$2e2bcd8739ae039)();
    (0, $a1b2017506b78aba$export$2e2bcd8739ae039)();
    (0, $c1dad78f44c606ce$export$2e2bcd8739ae039)("#js-nav-about-us-button", "#js-menu-dropdown", "hidden");
    (0, $c1dad78f44c606ce$export$2e2bcd8739ae039)("#js-nav-about-us-mobile-button", "#js-menu-mobile-dropdow", "hidden");
    (0, $c1dad78f44c606ce$export$2e2bcd8739ae039)("#js-nav-mobile-button", "#js-nav-mobile-menu", "hidden", "#site-body");
    (0, $c1dad78f44c606ce$export$2e2bcd8739ae039)("#js-location-switcher-left-button", "#js-location-switcher-left-dropdown", "hidden");
    (0, $c1dad78f44c606ce$export$2e2bcd8739ae039)("#js-location-switcher-right-button", "#js-location-switcher-right-dropdown", "hidden");
    (0, $c1dad78f44c606ce$export$2e2bcd8739ae039)("#js-nav-what-we-do-mobile-button", "#js-nav-key-pillars-mobile", "hidden");
    (0, $c1dad78f44c606ce$export$2e2bcd8739ae039)("#js-lang-switcher-mobile-button", "#js-lang-switcher-mobile-dropdown", "hidden");
    var globalToggleClose = function() {
        window.addEventListener("click", function(e) {
            var outermostElement = e.target.closest("[data-toggle]");
            if (outermostElement) return;
            console.log(e.target);
            if (e.target.tagName === "BUTTON") return;
            var allToggleBtns = document.querySelectorAll("[data-btn-toggle]");
            allToggleBtns.forEach(function(elm) {
                elm.classList.remove("is-active");
                elm.nextElementSibling.classList.add("hidden");
            });
        });
    };
    globalToggleClose();
});

})();
//# sourceMappingURL=app.js.map
